import React, { useState, useRef, useEffect } from 'react';
import {
  ListItem,
  Checkbox,
  IconButton,
  ListItemText,
  ListItemSecondaryAction,
  TextField,
  Menu,
  MenuItem,
  Popover,
  Button,
  Box,
  Typography,Chip ,Stack
} from '@mui/material';
import { format } from 'date-fns';
import { CalendarOutlined, DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons';
import { LocalizationProvider, DateTimePicker,MobileDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const TaskItem = ({ task, onToggleComplete, onDelete, onEdit,type,onDateChange }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editText, setEditText] = useState(type === "tasks" ? task.title : task.question);
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteAnchorEl, setDeleteAnchorEl] = useState(null);
  const inputRef = useRef(null);
  const [value, setValue] = useState(task?.due_by || null);
  const [tempValue, setTempValue] = useState(null);
  const [open, setOpen] = useState(false);

  const handleAccept = (newValue) => {
    setValue(newValue);  // Set final value on OK
    setOpen(false);
    onDateChange(task.id, newValue);
  };

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    setIsEditing(true);
    closeMenu();
  };

  const handleDeleteClick = (event) => {
    setDeleteAnchorEl(event.currentTarget);
    closeMenu();
  };

  const closeDeletePopover = () => {
    setDeleteAnchorEl(null);
  };

  const confirmDelete = () => {
    onDelete(task.id);
    closeDeletePopover();
  };

  const handleSave = () => {
    if (editText.trim()) {
      onEdit(task.id, editText.trim());
      setIsEditing(false);
    }
  };

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  return (
    <>
    <ListItem
      style={{ padding: "0px",right:"0px" }}
    >
      <Checkbox
        checked={type === "tasks" ? !!task?.completed_at : !!task?.answer}
        style={{marginBottom:"auto"}}
        onChange={(e) => onToggleComplete(task.id,e)} // pass id to parent
      />
      {isEditing ? (
        <TextField
          inputRef={inputRef}
          value={editText}
          onChange={(e) => setEditText(e.target.value)}
          size="small"
          style={{ width: "80%" }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSave();
          }}
          onBlur={handleSave}
        />
      ) : (
        <ListItemText
          primary={<Typography sx={{ width:"90%",lineBreak:"normal",fontSize:"0.9rem"}}>
          {type === "tasks" ? (
    (() => {
      const title = task?.title || "";
      if (title.includes('\n')) {
        const [boldText, ...rest] = title.split('\n');
        return (
          <>
            <strong ><span dangerouslySetInnerHTML={{ __html: boldText }}></span></strong>
            {rest.map((line, index) => (
              <React.Fragment key={index}>
                <br />
               <span dangerouslySetInnerHTML={{ __html: line }} style={{fontSize:"0.8rem"}}></span>
              </React.Fragment>
            ))}
          </>
        );
      }
      return <strong ><span dangerouslySetInnerHTML={{ __html: title }}></span></strong>;
    })()
  ) : task?.question}
        </Typography>}
          sx={{ textDecoration: task?.completed_at || task?.answer ? 'line-through' : 'none'}}
        />
      )}
       <ListItemSecondaryAction sx={{right:"0px",top:"18%"}}>
    <IconButton onClick={openMenu} sx={{padding:"0px 0px"}}>
      <MoreOutlined style={{width:"18px"}}/>
    </IconButton>

    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={closeMenu}
    >
      <MenuItem onClick={handleEdit}>
        <EditOutlined />
        <span style={{ marginLeft: "10px" }}>Edit</span>
      </MenuItem>
      <MenuItem onClick={handleDeleteClick}>
        <DeleteOutlined />
        <span style={{ marginLeft: "10px" }}>Delete</span>
      </MenuItem>
    </Menu>

    <Popover
      open={Boolean(deleteAnchorEl)}
      anchorEl={deleteAnchorEl}
      onClose={closeDeletePopover}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
    >
      <Box p={2}>
        <div>Are you sure you want to delete this task?</div>
        <Box mt={1} display="flex" justifyContent="flex-end" gap={1}>
          <Button size="small" onClick={closeDeletePopover}>Cancel</Button>
          <Button size="small" color="error" variant="contained" onClick={confirmDelete}>
            Delete
          </Button>
        </Box>
      </Box>
    </Popover>
  </ListItemSecondaryAction>
    </ListItem>
    {task?.completed_at ?
    <Stack direction="row" spacing={1} sx={{marginLeft:"40px",marginBottom:"20px",marginTop:"-5px"}}>
    <Chip label={`Completed: ${format(new Date(task?.completed_at), "EEE dd MMMM yyyy")}`} variant="outlined" sx={{height:"20px",fontSize:"10px",padding:"0px"}}/>
    </Stack>
    :
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction="row" spacing={1} sx={{marginLeft:"40px",marginBottom:"20px"}}>
      <Chip
            icon={<CalendarOutlined style={{marginLeft:"10px"}}/>}
            label={!value ? "Due by" :dayjs(value).format('ddd, DD MMM YYYY, hh:mm A')}
            onClick={() => setOpen(true)}
            sx={{ cursor: 'pointer', bgcolor: !value ? '#f0f0f0' : '#e3f2fd'}}
          />

<MobileDateTimePicker
          open={open}
          value={tempValue}
          onChange={(newValue) => setTempValue(newValue)}  // Update tempValue as user picks
          onAccept={handleAccept}                         // Commit on OK
          onClose={() => setOpen(false)}
          renderInput={() => <div style={{ display: 'none' }} />}
          sx={{ display: 'none' }}
          style={{display:"none"}}
        />
      </Stack>
    </LocalizationProvider>
}
     </>
  );
};

export default TaskItem;
